import React, { Component } from 'react';
import uploadDocuments from '../../upload-documents.js';


let currentElement;
class AccountUpload extends Component {
	componentWillMount() {
		currentElement = uploadDocuments.init(this.props.match.params.page);
	}

	componentWillUnmount() {
		uploadDocuments.setAccountLinkUploadDocumentsIcon();
		currentElement.classList.remove('menu--is-open');
		currentElement.parentNode.removeChild(currentElement);
	}

	render() {
		return (
			<div id="upload-documents" />
		);
	}
}

AccountUpload.propTypes = {
	params: React.PropTypes.object
};

export default AccountUpload;



// WEBPACK FOOTER //
// ./mobile-core/src/components/account/account-upload.js